/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type StoreManagementEditItemRequest = {
    id: number;
    categoryId?: number;
    subCategoryId?: number;
    code?: string;
    type?: string;
    language?: string;
    name?: string;
    nameEn?: string;
    nameCn?: string;
    optioNames?: string;
    optioNamesEn?: string;
    optioNamesCn?: string;
    company?: string;
    companyEn?: string;
    companyCn?: string;
    isPrice?: boolean;
    price?: number;
    salePrice?: number;
    isQuantity?: boolean;
    quantity?: number;
    context?: string;
    contextEn?: string;
    contextCn?: string;
    openStatus?: StoreManagementEditItemRequest.openStatus;
    releaseSetting?: StoreManagementEditItemRequest.releaseSetting;
    postDate?: string;
    saleId?: number;
    saleCode?: string;
    startDate?: string;
    endDate?: string;
};

export namespace StoreManagementEditItemRequest {

    export enum openStatus {
        HOLD = 'hold',
        RELEASE = 'release',
        NO_RELEASE = 'no_release',
    }

    export enum releaseSetting {
        NOW = 'now',
        DATE = 'date',
    }


}

